import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { StateMasterProvider } from "../contexts/StateMasterContext";
import { DistrictProvider } from "../contexts/DistrictContext";
import { CountryProvider } from "../contexts/CountryContext";
import { TalukProvider } from "../contexts/TalukContext";
import { CityProvider } from "../contexts/CityContext";
import { AuthProvider } from "../contexts/JWTContext";
import { DialogProvider } from "../contexts/DialogContext";

export const CityComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <CityProvider key={0} />,
        <TalukProvider key={1} />,
        <DistrictProvider key={2} />,
        <CountryProvider key={3} />,
        <StateMasterProvider key={4} />,
        <DialogProvider key={5} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
